import * as types from '../actions/types';
import moment from 'moment-timezone';

export const initialDate = (riyadhTime) => {
  console.log('initialDate', riyadhTime);
  return riyadhTime
    .set({ second: 0, millisecond: 0 })
    .add(150, 'minutes')
    .add(30 - (riyadhTime.minute() % 30), 'minutes');
};

const INITIAL_STATE = {
  gender: 'all',
  date: moment().tz("Asia/Riyadh"),
  currentTime: moment().tz("Asia/Riyadh"),
  selectedTime: null,
  is_urgent: 'not-urgent',
  repeatClasses: null,
  days: [],
  studentNotes: '',
  schedule_hours: [],
  class_type: 'one_class',
  last_selected_schedule: null,
};

export const bookingFlowReducer = (
  state = INITIAL_STATE,
  { payload, type, error }
) => {
  switch (type) {
    case types.SET_BOOKING_FLOW_DATA:
      return {
        ...state,
        ...payload,
      };

    case types.SET_BOOKING_FLOW_CURRENT_TIME:
      return {
        ...state,
        currentTime: moment(payload).tz("Asia/Riyadh"),
      };

    default:
      return state;
  }
};
